module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/star-b0370d7f688712eb42a2a5ded5b0190c.svg";